import React, { useState, useEffect } from 'react';
import api from '../services/api';

const BandMessage = () => {
    const [message, setMessage] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get('/admin/band-message/public')
            .then(res => {
                if (res.data.success) setMessage(res.data.data);
            })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    if (loading || !message) return null;

    return (
        <section className="py-12 sm:py-20 px-4 sm:px-6">
            <div className="max-w-4xl mx-auto">
                <div className="text-center mb-8 sm:mb-12">
                    <h2 className="text-3xl sm:text-5xl font-black gradient-text">
                        Message from the Band
                    </h2>
                </div>

                <div className="glass-card p-8 sm:p-12 border border-blue-600/30 relative overflow-hidden">
                    {/* Decorative quote mark */}
                    <div className="absolute top-4 left-6 text-blue-600/20 text-[8rem] leading-none font-serif select-none pointer-events-none" aria-hidden="true">
                        &ldquo;
                    </div>

                    <div className="relative z-10">
                        <h2 className="text-2xl sm:text-3xl font-black gradient-text mb-6">
                            {message.title}
                        </h2>

                        <p className="text-gray-300 text-base sm:text-lg leading-relaxed whitespace-pre-wrap">
                            {message.body}
                        </p>

                        {message.author && (
                            <p className="mt-6 text-blue-400 font-semibold text-sm sm:text-base">
                                — {message.author}
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BandMessage;
